import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { TIPO_DOCUMENTAL, UnidadDocumental, UnidadDocumentalSimple } from '../../../core/model/inventories';
import { Page } from '../../../core/model/page';
import { ResizedEvent } from '../../../core/model/resized-event';
import { InventariosService } from '../../../core/services/inventarios.service';

@Component({
  selector: 'app-unidades-documentales',
  templateUrl: './unidades-documentales.component.html',
  styleUrls: ['./unidades-documentales.component.css']
})
export class UnidadesDocumentalesComponent implements OnInit {
  @ViewChild('tableDocumentalUnits') table: DatatableComponent;

  @Input() id: number;
  @Input() unidadesDocumentales: UnidadDocumental;
  @Output() unidadesDocumentalesChange = new EventEmitter<UnidadDocumental>();

  @Input() set hasShowLocation(isInLocation: boolean) {
    if (isInLocation && !this.unidadesDocumentales) {
      this.getUnidadesDocumentales();
    }
  }

  page = new Page();
  loading = false;

  unidadesDocumentalesSimples: UnidadDocumentalSimple[] = [];

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  constructor(private inventoryService: InventariosService) { }

  ngOnInit() {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  changeRowsTable() {
    this.page.pageNumber = 0;
    this.table.recalculate();
    this.getUnidadesDocumentales();
  }

  private getUnidadesDocumentales() {
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + this.page.size;
    this.getPaginationData(inicio, fin);
  }

  private getPaginationData(inicio: number, fin: number) {
    this.loading = true;
    this.inventoryService.getUnidadesDocumentales(this.id, inicio, fin)
      .subscribe((value: UnidadDocumental) => {
        this.unidadesDocumentales = value;
        this.page.totalElements = value.totalUnidades;
        this.unidadesDocumentalesChange.emit(value);
        this.crearUnidadesDocumentalesSimples(value);
        this.loading = false;
      },
        error => {
          this.loading = false;
        });
  }

  private crearUnidadesDocumentalesSimples(value: UnidadDocumental) {
    const expedientesSimples: UnidadDocumentalSimple[] = value.expedientes.map(expediente => {
      return {
        id: expediente.id,
        tipoDocumental: expediente.tipoDocumental,
        fechaCreacion: expediente.fechaCreacion,
        estado: expediente.estado
      };
    });

    const azsSimples: UnidadDocumentalSimple[] = value.azs.map(az => {
      return {
        id: az.id,
        tipoDocumental: az.tipoDocumental,
        fechaCreacion: az.fechaCreacion,
        estado: az.estado
      };
    });

    this.unidadesDocumentalesSimples = expedientesSimples.concat(azsSimples);
    // this.page.totalElements = this.unidadesDocumentalesSimples.length;
  }

  onResizedTable(event: ResizedEvent) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  changePage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getUnidadesDocumentales();
  }

  isExpediente(tipoDocumental: TIPO_DOCUMENTAL): boolean {
    return tipoDocumental == TIPO_DOCUMENTAL.expediente;
  }

  getDocumentalTypeText(tipoDocumental: TIPO_DOCUMENTAL): string {
    return TIPO_DOCUMENTAL[tipoDocumental];
  }

  loadInventoryRecord(idExpediente) {
    this.inventoryService.goToRecordDetailById(idExpediente);
  }

  loadInventoryAZ(idAz: string) {
    this.inventoryService.goToAz(idAz);
  }

}
